import { ProductCardProps } from '@ui/product/product-card.tsx';
import { useNavigate } from 'react-router-dom';
import { usePopularProductsService } from '../../entites/product';
import { useCartProductsStore } from '../../entites/cart/use-cart-products.store.ts';
import { useUser } from '../../entites/authorization/use-user.ts';
import { useFavoriteProductsStore } from '../../entites/favorite/use-favorite-products.store.ts';

export function usePopularProducts() {
  const { data } = usePopularProductsService();

  const navigate = useNavigate();

  const { isUseCache } = useUser();

  const { isProductInCart, insertProduct } = useCartProductsStore({
    isUseCache,
  });
  const favoriteStore = useFavoriteProductsStore({
    isUseCache,
  });

  const mapped = data?.map<ProductCardProps>((product) => {
    return {
      image: product.main_photo || undefined,
      title: product.name,
      price: product.price || '',
      isShowPrice: true,
      description: product.category_name || '',
      isSelected: isProductInCart(product.id),
      isFavoriteSelected: favoriteStore.isFavorite(product.id),
      onPressFavorite: () => favoriteStore.invertProduct(product),
      onPress: () => navigate(`/products/${product.id}`),
      onPressAction: () => {
        if (isProductInCart(product.id)) {
          navigate(`/products/${product.id}`);
        } else {
          insertProduct(product);
        }
      },
      isFavoriteShow: true,
    };
  });

  const array = Array(10)
    .fill(undefined)
    .map(() => ({
      isLoading: true,
    }));

  return {
    data: mapped || array,
  };
}
